import {
  faArrowRightArrowLeft,
  faVault,
  faUser,
  faCalendar,
  faSackDollar,
  faBoxes,
} from '@fortawesome/pro-regular-svg-icons'

import { Icon } from '@flecto/ui'
import { type FilterField } from '@flecto/ui/@shared/Filters/components/multi-select/filterTypeConfig'

export function useBookingFilterFields() {
  const bookingFilterFields: FilterField[] = [
    {
      key: 'status',
      type: 'booking-status',
      label: 'accordion.labels.bookingStatus',
      icon: <Icon icon={faArrowRightArrowLeft} />,
    },
    {
      key: 'payment-status',
      type: 'payment-status',
      label: 'accordion.labels.paymentStatus',
      icon: <Icon icon={faSackDollar} />,
    },
    {
      key: 'deposit-status',
      type: 'deposit-status',
      label: 'accordion.labels.depositStatus',
      icon: <Icon icon={faVault} />,
    },
    {
      key: 'date-range',
      type: 'date-range',
      label: 'accordion.labels.bookingDates',
      icon: <Icon icon={faCalendar} />,
    },
    {
      key: 'customers',
      type: 'customers',
      label: 'accordion.labels.customers',
      searchable: true,
      icon: <Icon icon={faUser} />,
    },
    {
      key: 'products',
      type: 'products',
      label: 'accordion.labels.products',
      searchable: true,
      icon: <Icon icon={faBoxes} />,
    },
  ]

  return bookingFilterFields
}
